import { Injectable } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CanActivate } from "@angular/router";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";
import { IUser } from "../interfaces/ilogin";

@Injectable()
export class RoleGuardService implements CanActivate {
    constructor(private router: Router,
        private readonly store: Store<IAppStore>,
        private activatedRoute: ActivatedRoute) {
    }

    canActivate(): boolean {
        // Allow access to login and deloittead routes without authentication
        const currentUrl = this.router.url;
        
        if (currentUrl === '/login' || currentUrl === '/deloittead' || currentUrl.startsWith('/deloittead') || currentUrl === '/businessfunctionselection') {
          return true;
        }
        // if user is not logged in we'll send them to the login page
        let user: IUser = null as IUser;
        this.store.select(e => e.user)
            .subscribe(e => {
                user = e;
            });
        
        // Check for proper authentication - user must have name or userName to be considered authenticated
        if (!user || (!user.userName && !user.name) || (user.userName === null && user.name === null) || (user.userName === '' && user.name === '')) {
            this.router.navigate(["/login"]);
            return false;
        }

        // get the data for the activated route so we can check the roles against the user
        if (this.activatedRoute.children && this.activatedRoute.children.length > 0) {
            const activatedRouteData: any = this.activatedRoute.children[0].data;

            if (activatedRouteData.value && activatedRouteData.value.security && activatedRouteData.value.security.roles) {
                const hasRole = activatedRouteData.value.security.roles.filter((r: string) => user.roles.indexOf(r) > -1);
                if (!hasRole.length) {
                    this.router.navigate(["/login"]);
                    return false;
                }
            }
        }
        return true;
    }
}